// extracted by mini-css-extract-plugin
export var actionText = "_hm-4";
export var container = "_hm-0";
export var leftSection = "_hm-1";
export var rightSection = "_hm-2";
export var settingsButton = "_hm-6";
export var settingsIcon = "_hm-7";
export var shortcut = "_hm-5";
export var shortcutGroup = "_hm-3";